import React from 'react';

import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import InfiniteScroll from 'react-infinite-scroll-component';
import {setBeerFiltersAC} from 'store/beers/beerSlice';

import {BeersTableRow} from './BeersTableRow';

export const BeersTableBody = () => {
  const dispatch = useSetGlobalState();
  const {beers, filters, totalCount, isLoading} = useGlobalState((state) => state.beers);
  const isEmpty = beers.length === 0;

  const handlePageChange = (page: number) => {
    dispatch(setBeerFiltersAC({...filters, perPage: (page + 1) * 14, page: page + 1}));
  };

  return isLoading && beers.length <= 0 ? (
    <div className="w-100 d-flex justify-content-center py-2">
      <div className="spinner-border spinner-border--gray" role="status" />
    </div>
  ) : (
    <div className="beers-table__body" id="scrollable-div">
      {isEmpty ? (
        <div className="beers-table-body__zero">
          <Icon icon="beers_zero_state" />
          <p>Currently there are no beers in base.</p>
        </div>
      ) : (
        <>
          <InfiniteScroll
            loader={<></>}
            dataLength={beers.length}
            next={() => handlePageChange(filters.page)}
            hasMore={beers.length < totalCount}
            scrollableTarget="scrollable-div"
          >
            {beers.map((beer) => (
              <BeersTableRow beer={beer} key={beer.id} />
            ))}
          </InfiniteScroll>
        </>
      )}
    </div>
  );
};
